/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 * Method which was used to create the 2d embeddings
 * @export
 * @enum {string}
 */
export enum DimensionalityReductionMethod {
    PCA = 'PCA',
    TSNE = 'TSNE',
    UMAP = 'UMAP'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const DimensionalityReductionMethodValidatorShape = [
    'PCA',
    'TSNE',
    'UMAP'
];
export const DimensionalityReductionMethodValidator = yup.mixed().oneOf(DimensionalityReductionMethodValidatorShape);
export const DimensionalityReductionMethodStringifyShapeProperties = {};
export const DimensionalityReductionMethodStringifyShape: StringSchema = {
    title: 'DimensionalityReductionMethod Stringifier',
    type: 'string'
};
export const DimensionalityReductionMethodStringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DimensionalityReductionMethodStringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function DimensionalityReductionMethodFromJSON(json: any): DimensionalityReductionMethod {
    return DimensionalityReductionMethodFromJSONTyped(json, false);
}
export function DimensionalityReductionMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): DimensionalityReductionMethod {
    return json as DimensionalityReductionMethod;
}
export function DimensionalityReductionMethodToJSON(value?: DimensionalityReductionMethod | null): any {
    return value as any;
}
